import CalendarModeBaseView from './CalendarModeBaseView';
import EventsCalendarViewMode from './EventsCalendarViewMode';
import DateFormatter from '../date/EventListingDateFormatter';
import { startOfDay, endOfDay } from '../date/DateHelpers';
import EventDayList from './html/EventDayList';

class CalendarDayView extends CalendarModeBaseView {
  constructor(eventEmitter, config) {
    super(
      eventEmitter,
      config,
      EventsCalendarViewMode.DAY,
    );

    this.setResultViews([
      new EventDayList(),
    ]);
  }

  async initDatepicker(DatePicker, { date, minDate, maxDate }) {
    this.datePicker = new DatePicker({
      date,
      minDate,
      maxDate,
      id: 'tn-event-calendar-input-day',
      label: 'Select Day',
      dateFormatter: DateFormatter.standardDate,
      rangeType: DatePicker.RangeType.DAY,
      onChange: this.onDateChange.bind(this),
    });
  }

  getRangeForSelectedDate() {
    const { selectedDate: date } = this;

    return {
      startDate: startOfDay(date),
      endDate: endOfDay(date),
    };
  }
}

export default CalendarDayView;
